import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import { LF } from './Constantes/general';
import { DatosAsegurado } from './formas/DatosAsegurado';

const API = ApiKeyFetch.instance();

export const LFDatosAsegurado = ({ dataUsuario: { cliCodigoCore }, qParams: { idCotizacion }, history }) => {
  useNavbarContext(PRODUCTOS.LINEAS_FINANCIERAS);
  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const { addWarningToast } = useCustomToast();
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit, reset } = methods;

  const onSubmit = async (data) => {
    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: LF.prodCodigoCore,
      pasoCodigo: 'informacionCliente',
      items: {
        cotCodigo: idCotizacion || '',
        datosCliente: data.datosCliente,
        usuCotiza: { usuCodigo: cliCodigoCore || '' },
        agente: data?.agente,
        datosCotizacion: data?.datosCotizacion,
      },
    };

    console.log(Data);

    let res;
    res = await API.post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);

    console.log(res);
    if (res.transaccion && res.id) {
      history.push(`${LF.urls.preguntas}?idCotizacion=${res.id}`);
    } else {
      reset({ ...data });
      try {
        if (res?.errorDescripcion?.mensajeValidacion) {
          addWarningToast(res?.errorDescripcion?.mensajeValidacion, { autoDismiss: false });
        } else {
          if (typeof res.errorDescripcion === 'string') {
            addWarningToast(res.errorDescripcion, { autoDismiss: false });
          } else {
            res.errorDescripcion.forEach((msg) => addWarningToast(msg, { autoDismiss: false }));
          }
        }
      } catch (e) {
        addWarningToast('Error desconocido', { autoDismiss: false });
      }
    }
    setLoading(false);
  };

  const loadData = useCallback(
    async (agentes = []) => {
      setLoading(true);
      const DataResumen = {
        cotDatos: {
          ambiente: ambienteAplicacion,
          cotCodigo: idCotizacion,
        },
      };
      try {
        let resResumen = await API.post(URLS_PHP_7.cotizacion.resumenCotizacion, DataResumen);

        const agente = agentes.find((item) => item.codigoAgente === resResumen?.cotConsulta?.carAsesor?.codigoAgente);
        reset({
          datosCotizacion: {
            ...resResumen?.cotConsulta?.prodDatos[0],
          },
          datosCliente: {
            ...resResumen?.cotConsulta?.carContratante,
          },
          agente,
        });
      } catch (error) {}
      setLoading(false);
    },
    [idCotizacion, reset]
  );

  const onSubmitError = (errors) => {};
  const getData = useCallback(async () => {
    setLoading(true);
    const Data = {
      datosCotizador: {
        prodCodigo: LF.prodCodigoCore,
        catPasoCodigo: 'validaciones',
        usuCotiza: {
          usuCodigo: cliCodigoCore,
        },
      },
    };
    let resp;
    try {
      resp = await API.post(URLS_PHP_7.cotizacion.catalogosCotizador, Data);
      console.log(resp);
      if (resp?.transaccion && resp.catalogo) {
        setCatalogo(resp.catalogo);
      }
    } catch (error) {}
    console.log(idCotizacion);
    if (idCotizacion) {
      loadData(resp?.catalogo?.permisos?.agentes);
      return;
    }
    setLoading(false);
  }, [cliCodigoCore, loadData, idCotizacion]);
  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS].breadCrumbPasosCotizacion[1]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS]?.pasosCotizacion}
          />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
              <DatosAsegurado
                catalogo={catalogo}
                clavesAgente={catalogo?.permisos?.agentes}
                onSubmitError={onSubmitError}
              />
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
